module.exports = __webpack_public_path__ + "img/9788959524747.a2180bd7.jpg";